/* eslint-disable */
import _m0 from "protobufjs/minimal";

export const protobufPackage = "protobuf_util";

/**
 * Inequality and equality comparison operators. See `compare.py` for a comparison function that
 * uses this operator
 */
export interface Op {
}

export enum Op_Enum {
  INVALID = 0,
  GT = 1,
  GE = 2,
  EQ = 3,
  NE = 4,
  LT = 5,
  LE = 6,
  UNRECOGNIZED = -1,
}

export function op_EnumFromJSON(object: any): Op_Enum {
  switch (object) {
    case 0:
    case "INVALID":
      return Op_Enum.INVALID;
    case 1:
    case "GT":
      return Op_Enum.GT;
    case 2:
    case "GE":
      return Op_Enum.GE;
    case 3:
    case "EQ":
      return Op_Enum.EQ;
    case 4:
    case "NE":
      return Op_Enum.NE;
    case 5:
    case "LT":
      return Op_Enum.LT;
    case 6:
    case "LE":
      return Op_Enum.LE;
    case -1:
    case "UNRECOGNIZED":
    default:
      return Op_Enum.UNRECOGNIZED;
  }
}

export function op_EnumToJSON(object: Op_Enum): string {
  switch (object) {
    case Op_Enum.INVALID:
      return "INVALID";
    case Op_Enum.GT:
      return "GT";
    case Op_Enum.GE:
      return "GE";
    case Op_Enum.EQ:
      return "EQ";
    case Op_Enum.NE:
      return "NE";
    case Op_Enum.LT:
      return "LT";
    case Op_Enum.LE:
      return "LE";
    case Op_Enum.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

function createBaseOp(): Op {
  return {};
}

export const Op = {
  encode(_: Op, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): Op {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseOp();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): Op {
    return {};
  },

  toJSON(_: Op): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<Op>, I>>(base?: I): Op {
    return Op.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Op>, I>>(_: I): Op {
    const message = createBaseOp();
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };
